// import React from "react";

// export function HiddenFileInputs({ controller }) {
//     return (
//         <>
//             <input
//                 ref={controller.fileInputRef}
//                 type="file"
//                 accept="image/*"
//                 className="hidden"
//                 onChange={controller.handleImageSelect}
//             />

//             <input
//                 ref={controller.zipInputRef}
//                 type="file"
//                 accept=".zip,application/zip,application/x-zip-compressed"
//                 className="hidden"
//                 onChange={controller.handleZipSelect}
//             />

//             <input
//                 ref={controller.excelInputRef}
//                 type="file"
//                 accept=".xlsx,.xls,.csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel,text/csv"
//                 className="hidden"
//                 onChange={controller.handleExcelFileSelect}
//             />
//         </>
//     );
// }

// export function StatPill({ children, tone = "default", className = "" }) {
//     const toneClass =
//         tone === "warning"
//             ? "border-amber-300 bg-amber-50 font-semibold text-amber-700"
//             : tone === "success"
//               ? "border-emerald-200 bg-emerald-50 font-medium text-emerald-700"
//               : tone === "info"
//                 ? "border-blue-200 bg-blue-50 font-medium text-blue-700"
//                 : "border bg-white text-gray-600";

//     return (
//         <span className={`rounded-full px-2.5 py-1 text-xs ${toneClass} ${className}`}>
//             {children}
//         </span>
//     );
// }

// export function ActionButton({
//     children,
//     onClick,
//     disabled = false,
//     variant = "default",
//     className = "",
//     type = "button",
// }) {
//     const variantClass =
//         variant === "primary"
//             ? "bg-[#01C37D] text-white hover:bg-[#00a96c]"
//             : variant === "blue"
//               ? "bg-blue-600 text-white hover:bg-blue-700"
//               : variant === "danger"
//                 ? "border border-red-200 bg-white text-red-600 hover:bg-red-50"
//                 : "border bg-white text-gray-700 hover:bg-gray-50";

//     return (
//         <button
//             type={type}
//             className={`h-9 rounded-lg px-3 text-sm font-medium disabled:opacity-60 ${variantClass} ${className}`}
//             disabled={disabled}
//             onClick={onClick}
//         >
//             {children}
//         </button>
//     );
// }

// export function SearchInput({ value, onChange, onClear, placeholder, className = "" }) {
//     return (
//         <div className={`relative ${className}`}>
//             <input
//                 className="h-9 w-[280px] rounded-lg border bg-white px-3 text-sm outline-none focus:border-[#01C37D]"
//                 placeholder={placeholder}
//                 value={value}
//                 onChange={(e) => onChange(e.target.value)}
//             />

//             {value && (
//                 <button
//                     type="button"
//                     className="absolute right-2 top-1/2 -translate-y-1/2 rounded px-1 text-xs text-gray-400 hover:text-gray-700"
//                     onClick={onClear}
//                 >
//                     ✕
//                 </button>
//             )}
//         </div>
//     );
// }

// export function PanelShell({ children, className = "" }) {
//     return (
//         <div className={`absolute left-0 top-11 z-50 rounded-xl border bg-white p-3 shadow-xl ${className}`}>
//             {children}
//         </div>
//     );
// }

import React from "react";

export function HiddenFileInputs({ controller }) {
  return (
    <>
      <input
        ref={controller.fileInputRef}
        type="file"
        accept="image/*"
        className="hidden"
        onChange={controller.handleImageSelect}
      />

      <input
        ref={controller.zipInputRef}
        type="file"
        accept=".zip,application/zip,application/x-zip-compressed"
        className="hidden"
        onChange={controller.handleZipSelect}
      />

      <input
        ref={controller.excelInputRef}
        type="file"
        accept=".xlsx,.xls,.csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel,text/csv"
        className="hidden"
        onChange={controller.handleExcelFileSelect}
      />
    </>
  );
}

export function StatPill({ children, tone = "default", className = "" }) {
  const toneClass =
    tone === "warning"
      ? "border-amber-300 bg-amber-50 font-semibold text-amber-700"
      : tone === "success"
        ? "border-emerald-200 bg-emerald-50 font-medium text-emerald-700"
        : tone === "info"
          ? "border-blue-200 bg-blue-50 font-medium text-blue-700"
          : "border border-gray-200 bg-white text-gray-600";

  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-1 text-xs ${toneClass} ${className}`}
    >
      {children}
    </span>
  );
}

export function ActionButton({
  children,
  onClick,
  disabled = false,
  variant = "default",
  className = "",
  type = "button",
}) {
  const variantClass =
    variant === "primary"
      ? "bg-[#01C37D] text-white hover:bg-[#00a96c]"
      : variant === "blue"
        ? "bg-blue-600 text-white hover:bg-blue-700"
        : variant === "danger"
          ? "border border-red-200 bg-white text-red-600 hover:bg-red-50"
          : "border border-gray-200 bg-white text-gray-700 hover:bg-gray-50";

  return (
    <button
      type={type}
      disabled={disabled}
      onClick={onClick}
      className={`inline-flex h-9 items-center justify-center rounded-lg px-3 text-sm font-medium transition-colors disabled:cursor-not-allowed disabled:opacity-60 ${variantClass} ${className}`}
    >
      {children}
    </button>
  );
}

export function SearchInput({
  value,
  onChange,
  onClear,
  placeholder,
  className = "",
}) {
  return (
    <div className={`relative ${className}`}>
      <input
        type="text"
        className="h-9 w-[280px] rounded-lg border border-gray-200 bg-white px-3 pr-8 text-sm outline-none transition-colors focus:border-[#01C37D]"
        placeholder={placeholder}
        value={value || ""}
        onChange={(event) => onChange?.(event.target.value)}
      />

      {!!value && (
        <button
          type="button"
          aria-label="Clear search"
          className="absolute right-2 top-1/2 -translate-y-1/2 rounded px-1 text-xs text-gray-400 hover:bg-gray-100 hover:text-gray-700"
          onClick={onClear}
        >
          ✕
        </button>
      )}
    </div>
  );
}

export function PanelShell({ children, className = "" }) {
  return (
    <div
      className={`absolute left-0 top-[calc(100%+8px)] z-[9999] max-h-[420px] overflow-visible rounded-xl border border-gray-200 bg-white p-3 shadow-2xl ${className}`}
    >
      {children}
    </div>
  );
}